import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import IMenuPanelState from '../../interfaces/states/IMenuPanelState';

const initialState: IMenuPanelState = {
  visible: false,
};

class MenuPanelReducer extends ImmerReducer<IMenuPanelState> {
  public toggle(): void {
    this.draftState.visible = !this.state.visible;
  }

  public resetMenuPanel(): void {
    this.draftState = initialState;
  }
}

export const MenuPanelActions = createActionCreators(MenuPanelReducer);
export const MenuPanelReducerFunction = createReducerFunction(MenuPanelReducer, initialState);
